import "./LeftNavigation.css";

import { Link } from "react-router-dom";

import { NavigationActiveElement } from "../../../models";
import { NavigationTooltip } from "./components";
import { useLeftNavigation } from "./useLeftNavigation";

interface LeftNavigationProps {
  activeElement?: NavigationActiveElement;
}

export const LeftNavigation = ({ activeElement }: LeftNavigationProps): JSX.Element => {
  const { navigationLogo, navigationActions, currentUserType, navigationFooter } = useLeftNavigation();

  return (
    <nav className={`Navigation ${currentUserType}Navigation`}>
      <Link to={navigationActions[0].route}>{navigationLogo}</Link>
      {navigationActions.map((action) => (
        <Link
          key={action.tooltipText}
          to={action.route}
          className={`NavigationElement${action.tooltipText === activeElement ? " NavigationElement_active" : ""}`}
        >
          <NavigationTooltip text={action.tooltipText}>{action.icon}</NavigationTooltip>
        </Link>
      ))}
      {navigationFooter}
    </nav>
  );
};
